import request from '@/utils/request'

export function create(userName, password, nickName, roleId) {
  return request({
    url: '/api/v1/user/create',
    method: 'post',
    data: { userName, password, nickName, roleId }
  })
}

export function deleteadmin(id) {
  return request({
    url: '/api/v1/user/softdelete',
    method: 'post',
    data: { id }
  })
}

export function update(roleId, nickName, avatar, id) {
  return request({
    url: '/api/v1/user/update',
    method: 'post',
    data: { roleId, nickName, avatar, id }
  })
}

export function updatepassword(oldPassword, password) {
  return request({
    url: '/api/v1/user/updatepassword',
    method: 'post',
    data: { oldPassword, password }
  })
}

export function resetpassword(id) {
  return request({
    url: '/api/v1/user/resetpassword',
    method: 'get',
    params: { id }
  })
}

export function querypage(data) {
  return request({
    url: '/api/v1/user/querypage',
    method: 'post',
    data
  })
}
